/**
 * @name Footer
 * @description Componente común footer de Talentry
 * @author Ricardo Guerra
 */

import React from 'react';
import i18n from 'i18next';
import styled from 'styled-components';
import moment from 'moment';

import { Lines } from '@components';
import { Typography } from '@styles';

const URL = 'https://assets.talentry.io/legal/AVISO+DE+PRIVACIDAD+TESSELAR.pdf';

const Footer = () => {
  return (
    <Styled.FooterWrapper>
      <Lines
        direction="horizontal"
        firstLine={{ size: 25, color: 'purple' }}
        secondLine={{ size: 75, color: 'blueMedium' }}
      />
      <Styled.FlexRow>
        <Typography.Text>
          {`${moment(Date.now()).format('YYYY')}, Talentry. ${i18n.t('Footer.allRightsReserved')}`}

          <Styled.DividerText> | </Styled.DividerText>

          {/* <Link to="">Feedback</Link>*/}

          <Typography.TextLink href="/">
            {`${i18n.t('Footer.noticePrivacy')}`}
          </Typography.TextLink>

          <Styled.DividerText> | </Styled.DividerText>

          <Typography.TextLink href={URL} target="_blank" rel="noopener noreferrer">
            {`${i18n.t('Footer.termsUse')}`}
          </Typography.TextLink>

          {/* <Link to="">Preguntas frecuentas</Link>*/}
        </Typography.Text>
      </Styled.FlexRow>
    </Styled.FooterWrapper>
  );
};

// *************************************
// STYLED COMPONENTS                               
// *************************************

const Styled = {};

Styled.FooterWrapper = styled.footer`
	position: absolute;
  width: 100%;
	height: 64px;
	bottom: 0;

	@media (max-width: 600px) {
		position: initial;
  }
`;

Styled.FlexRow = styled.div`
	display: flex;
  flex-direction: row;
	align-items: center;
	justify-content: center;
	height: 60px;
  padding: 16px;
`;

Styled.DividerText = styled.span`
	margin: 0px 8px;
`;

export default Footer;